module.exports = __webpack_public_path__ + "img/score_10.4942c88a.png";